import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment, @typescript-eslint/prefer-ts-expect-error
// @ts-ignore This import fails when compiling to CJS.
import { Menu } from '@headlessui/react';
import { useRef } from 'react';
import { useModifiedPopper } from '../hooks/useModifiedPopper';
import { useOnClickOutside } from '../hooks/useOnClickOutside';
import { useOnOff } from '../hooks/useOnOff';
import { Portal } from '../root-layout/Portal';
import { MenuItems } from './MenuItems';
import { useContextMenuPlacement } from './useContextMenuPlacement';
export function DropdownMenu(props) {
    const { trigger, ...otherProps } = props;
    if (trigger === 'contextMenu') {
        return _jsx(DropdownContextMenu, { ...props });
    }
    return (_jsx(DropdownClickMenu, { ...otherProps, children: props.children }));
}
function DropdownContextMenu(props) {
    const { children, onSelect, as: Wrapper = 'div', placement = 'right-start', options, ...otherProps } = props;
    const { isPopperElementOpen, closePopperElement, handleContextMenu, setPopperElement, styles, attributes, } = useContextMenuPlacement(placement);
    const ref = useRef(null);
    useOnClickOutside(ref, closePopperElement);
    const { style = {}, ...otherWrapperProps } = otherProps;
    return (_jsx(Wrapper, { style: { ...(!props?.as && { display: 'contents' }), ...style }, ...otherWrapperProps, onContextMenu: handleContextMenu, children: _jsxs(_Fragment, { children: [isPopperElementOpen && (_jsx(Portal, { children: _jsx("div", { ref: ref, children: _jsx("div", { ref: setPopperElement, style: styles.popper, ...attributes.popper, children: _jsx(Menu, { children: _jsx(MenuItems, { itemsStatic: true, onSelect: (selected) => {
                                        closePopperElement();
                                        onSelect(selected);
                                    }, options: options }) }) }) }) })), children] }) }));
}
function DropdownClickMenu(props) {
    const { placement = 'bottom-start', onSelect, ...otherProps } = props;
    const [isOpened, , closeItems, toggle] = useOnOff(false);
    const ref = useRef(null);
    useOnClickOutside(ref, closeItems);
    const { setReferenceElement, setPopperElement, popperProps } = useModifiedPopper({ placement, offset: 6 });
    return (_jsxs(Menu, { children: [_jsx(Menu.Button, { ref: setReferenceElement, onClick: toggle, children: props.children }), isOpened && (_jsx(Portal, { children: _jsx("div", { ref: ref, children: _jsx("div", { ref: setPopperElement, ...popperProps, children: _jsx(MenuItems, { itemsStatic: true, onSelect: (selected) => {
                                closeItems();
                                onSelect(selected);
                            }, ...otherProps }) }) }) }))] }));
}
//# sourceMappingURL=DropdownMenu.js.map